"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const addControlsToParent_1 = __importDefault(require("../functions/controlOperations/addControlsToParent"));
const updateControlById_1 = __importDefault(require("../functions/controlOperations/updateControlById"));
const flatBuildOrdersControls_1 = __importDefault(require("../functions/flatters/flatBuildOrdersControls"));
const AppStateConstants_1 = require("../types/AppStateConstants");
const Controls_1 = require("../types/Controls");
const appStateSelectBOInitialPageId_1 = __importDefault(require("./appStateSelectBOInitialPageId"));
const appStateSelectBOPaletteShadeBases_1 = __importDefault(require("./appStateSelectBOPaletteShadeBases"));
const appStateSelectFullScreenCameraIsOpened_1 = __importDefault(require("./appStateSelectFullScreenCameraIsOpened"));
const controlIsLegacy_1 = __importDefault(require("./controlIsLegacy"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const setObjectPropByPath_1 = __importDefault(require("./setObjectPropByPath"));
const appStateSelectRoutingStackCurrentRoute_1 = __importDefault(require("./appStateSelectRoutingStackCurrentRoute"));
const shallowCompare_1 = __importDefault(require("./shallowCompare"));
const appStateSelectRoutingStack_1 = __importDefault(require("./appStateSelectRoutingStack"));
const applicationRoutingStackEnsureMaxLenghtNotExceeded_1 = __importDefault(require("./applicationRoutingStackEnsureMaxLenghtNotExceeded"));
const routingStackGetUniqueKey_1 = __importDefault(require("./routingStackGetUniqueKey"));
const cleanDatabasePath_1 = __importDefault(require("../FirebaseDatabaseCache/cleanDatabasePath"));
const setValueLikeFirebase_1 = __importDefault(require("./setValueLikeFirebase"));
const cleanUndefinedFromValue_1 = __importDefault(require("./cleanUndefinedFromValue"));
const updateDatabaseCache_1 = __importDefault(require("../FirebaseDatabaseCache/updateDatabaseCache"));
const appStateBuildReducer = (args) => {
    const localStorageEmptyListeners = {};
    let defaultState = {
        needsToRestart: false,
        appId: args.appId,
        projectId: args.projectId,
        loadingPage: {
            isOpened: false,
            lottieUrl: undefined,
        },
        localStorage: {
            listeners: localStorageEmptyListeners,
        },
        firebaseRealtimeDatabase: {
            cache: [],
        },
        fullScreenCamera: {
            isOpened: false,
            isRecord: false,
        },
        functions: {
            areEnabled: args.functions.areEnabled,
            definitions: args.functions.definitions,
        },
        buildOrders: args.buildOrders,
        routing: {
            maxRoutesOnStack: 30,
            stack: [],
        },
        flattedControls: (0, flatBuildOrdersControls_1.default)(args.buildOrders),
    };
    const initialPageId = (0, appStateSelectBOInitialPageId_1.default)(defaultState);
    if (initialPageId) {
        defaultState = Object.assign(Object.assign({}, defaultState), { routing: Object.assign(Object.assign({}, defaultState.routing), { stack: [
                    {
                        key: (0, routingStackGetUniqueKey_1.default)([]),
                        params: {},
                        pageId: initialPageId,
                    },
                ] }) });
    }
    return (paramState, action) => {
        var _a, _b, _c, _d, _e, _f;
        const state = paramState !== null && paramState !== void 0 ? paramState : defaultState;
        switch (action.type) {
            case AppStateConstants_1.AppStateConstants.OVEWRITE_STATE: {
                if (state === action.payload) {
                    return state;
                }
                return action.payload;
            }
            case AppStateConstants_1.AppStateConstants.LOADING_PAGE_REQUEST_CLOSE: {
                if (!state.loadingPage.isOpened) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { loadingPage: {
                        isOpened: false,
                        lottieUrl: undefined,
                    } });
            }
            case AppStateConstants_1.AppStateConstants.LOADING_PAGE_REQUEST_OPEN: {
                if (state.loadingPage.isOpened) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { loadingPage: {
                        isOpened: true,
                        lottieUrl: action.payload.lottieUrl,
                    } });
            }
            case AppStateConstants_1.AppStateConstants.FIREBASE_REALTIME_DATABASE_SET_CACHE: {
                if (state.firebaseRealtimeDatabase.cache === action.payload) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { firebaseRealtimeDatabase: Object.assign(Object.assign({}, state.firebaseRealtimeDatabase), { cache: action.payload }) });
            }
            case AppStateConstants_1.AppStateConstants.FIREBASE_REALTIME_DATABASE_UPDATE_CACHE: {
                const updated = (0, updateDatabaseCache_1.default)({
                    currentCacheData: state.firebaseRealtimeDatabase.cache,
                    currentTimeInMillis: Date.now(),
                    data: action.payload.data,
                    route: action.payload.route,
                });
                if (updated === state.firebaseRealtimeDatabase.cache) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { firebaseRealtimeDatabase: Object.assign(Object.assign({}, state.firebaseRealtimeDatabase), { cache: updated }) });
            }
            case AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_ADD_LISTENER: {
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { listeners: Object.assign(Object.assign({}, state.localStorage.listeners), { [action.payload.path]: [
                                ...(state.localStorage.listeners[action.payload.path] || []),
                                action.payload.listener,
                            ] }) }) });
            }
            case AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_CLEAN_LISTENERS_AND_UPDATES: {
                if (state.localStorage.listeners === localStorageEmptyListeners
                    && state.localStorage.lastUpdates === undefined) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { localStorage: {
                        listeners: localStorageEmptyListeners,
                        lastUpdates: undefined,
                        data: state.localStorage.data,
                    } });
            }
            case AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_SET_DATA: {
                if (state.localStorage.data === action.payload) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { data: action.payload }) });
            }
            case AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_CLEAN_DATA: {
                if (state.localStorage.data === undefined) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { data: undefined }) });
            }
            case AppStateConstants_1.AppStateConstants.LOCAL_STORAGE_APPLY_UPDATES: {
                const updates = action.payload;
                let localDbData = state.localStorage.data;
                Object.entries(updates).forEach(([rawPath, value]) => {
                    const arrayPath = (0, cleanDatabasePath_1.default)(rawPath);
                    if ((0, ts_validators_1.valueIsArray)(value) || (0, ts_validators_1.valueIsRecord)(value)) {
                        Object.entries(value).forEach(([valueKey, subValue]) => {
                            localDbData = (0, setValueLikeFirebase_1.default)({
                                data: localDbData || {},
                                newValue: subValue,
                                path: [...arrayPath.split('/'), valueKey],
                            });
                        });
                    }
                    else {
                        localDbData = (0, setValueLikeFirebase_1.default)({
                            data: localDbData || {},
                            newValue: value,
                            path: arrayPath.split('/'),
                        });
                    }
                });
                if (localDbData) {
                    const cleanedValue = (0, cleanUndefinedFromValue_1.default)(localDbData);
                    localDbData = (0, ts_validators_1.valueIsRecord)(cleanedValue) ? cleanedValue : undefined;
                }
                if (localDbData === state.localStorage.data) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { lastUpdates: updates, data: localDbData }) });
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_GO_BACK: {
                const currentStack = (0, appStateSelectRoutingStack_1.default)(state);
                if (currentStack.length <= 1) {
                    return state;
                }
                const newStack = [...currentStack];
                newStack.pop();
                return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: newStack }) });
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_CLEAR_AFTER_REPLACE_ANIMATION: {
                const currentRoute = (0, appStateSelectRoutingStackCurrentRoute_1.default)(state);
                if (!currentRoute) {
                    return state;
                }
                const newStack = [currentRoute];
                return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: newStack }) });
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_SET_CURRENT_ROUTE_TRANSITION: {
                const currentRoute = (0, appStateSelectRoutingStackCurrentRoute_1.default)(state);
                if (!currentRoute) {
                    return state;
                }
                const currentStack = (0, appStateSelectRoutingStack_1.default)(state);
                const newStack = [
                    ...currentStack.slice(0, currentStack.length - 1),
                    Object.assign(Object.assign({}, currentRoute), { transition: action.payload }),
                ];
                return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: (0, applicationRoutingStackEnsureMaxLenghtNotExceeded_1.default)({
                            maxRoutesOnStack: state.routing.maxRoutesOnStack,
                            stack: newStack,
                        }) }) });
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_REPLACE_TOP: {
                const currentRoute = (0, appStateSelectRoutingStackCurrentRoute_1.default)(state);
                if (!currentRoute) {
                    const newStack = [
                        {
                            pageId: action.payload.pageId,
                            transition: action.payload.transition,
                            params: (_a = action.payload.params) !== null && _a !== void 0 ? _a : {},
                            key: (0, routingStackGetUniqueKey_1.default)([]),
                        },
                    ];
                    return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: (0, applicationRoutingStackEnsureMaxLenghtNotExceeded_1.default)({
                                maxRoutesOnStack: state.routing.maxRoutesOnStack,
                                stack: newStack,
                            }) }) });
                }
                const currentStack = (0, appStateSelectRoutingStack_1.default)(state);
                const newStack = [
                    ...currentStack.slice(0, currentStack.length - 1),
                    {
                        pageId: action.payload.pageId,
                        transition: action.payload.transition,
                        params: (_b = action.payload.params) !== null && _b !== void 0 ? _b : {},
                        key: (0, routingStackGetUniqueKey_1.default)(currentStack),
                    },
                ];
                return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: (0, applicationRoutingStackEnsureMaxLenghtNotExceeded_1.default)({
                            maxRoutesOnStack: state.routing.maxRoutesOnStack,
                            stack: newStack,
                        }) }) });
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_DANGEROUSLY_SET_CURRENTPAGE_PARAM: {
                const currentRoute = (0, appStateSelectRoutingStackCurrentRoute_1.default)(state);
                if (!currentRoute) {
                    return state;
                }
                // This is a direct mutation because users
                // do not expect a re-render when a page param is setted
                // so no update is reported from store and only de value
                // is changed
                currentRoute.params[action.payload.paramKey] = action.payload.paramValue;
                return state;
            }
            case AppStateConstants_1.AppStateConstants.ROUTING_PUSH: {
                const currentRoute = (0, appStateSelectRoutingStackCurrentRoute_1.default)(state);
                if (currentRoute
                    && currentRoute.pageId === action.payload.pageId
                    && ((currentRoute.params === undefined && action.payload.params === undefined)
                        || (currentRoute.params
                            && action.payload.params
                            && (0, shallowCompare_1.default)(currentRoute.params)(action.payload.params)))) {
                    return state;
                }
                const currentStack = (0, appStateSelectRoutingStack_1.default)(state);
                const newStack = [
                    ...currentStack,
                    {
                        pageId: action.payload.pageId,
                        transition: action.payload.transition,
                        params: (_c = action.payload.params) !== null && _c !== void 0 ? _c : {},
                        key: (0, routingStackGetUniqueKey_1.default)(currentStack),
                    },
                ];
                return Object.assign(Object.assign({}, state), { routing: Object.assign(Object.assign({}, state.routing), { stack: (0, applicationRoutingStackEnsureMaxLenghtNotExceeded_1.default)({
                            maxRoutesOnStack: state.routing.maxRoutesOnStack,
                            stack: newStack,
                        }) }) });
            }
            case AppStateConstants_1.AppStateConstants.BO_SET: {
                if (state.buildOrders === action.payload.buildOrders
                    && state.flattedControls === action.payload.flattedControls) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { buildOrders: action.payload.buildOrders, flattedControls: action.payload.flattedControls });
            }
            case AppStateConstants_1.AppStateConstants.BO_REQUEST_RESET: {
                if (state.needsToRestart) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { needsToRestart: true });
            }
            case AppStateConstants_1.AppStateConstants.BO_UPDATE_CONTROL_BY_ID: {
                const { control, dataToUpdate, } = action.payload;
                const { buildOrders, flattedControls } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId: control.id,
                    dataToUpdate,
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                return Object.assign(Object.assign({}, state), { flattedControls,
                    buildOrders });
            }
            case AppStateConstants_1.AppStateConstants.BO_UPDATE_CONTROL_PROP_BY_PATH_IF_EXIST: {
                const instructions = action.payload;
                const controlInfo = (_d = state.flattedControls) === null || _d === void 0 ? void 0 : _d[instructions.controlId];
                if (!controlInfo) {
                    return state;
                }
                const { control: controlToUpdate } = controlInfo;
                if ((0, getValueByPathFromUnknown_1.default)(controlToUpdate, instructions.propPath) === instructions.value) {
                    return state;
                }
                const newObject = (0, setObjectPropByPath_1.default)(controlToUpdate, instructions.propPath, instructions.value);
                const { buildOrders, flattedControls } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId: instructions.controlId,
                    dataToUpdate: newObject,
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                return Object.assign(Object.assign({}, state), { flattedControls,
                    buildOrders });
            }
            case AppStateConstants_1.AppStateConstants.BO_UPDATE_CONTROL_TO_LIST: {
                const { shouldAddTabsToList, controlId, inverted, categoryField, listItemControlTemplate, controls: listControls, listStyles, functionsToUpdate, filterEnabled, filterProperty, filterPlaceholder, listControlsInfo, isHorizontal, numColumns, } = action.payload;
                const baseControlInfo = state.flattedControls[controlId];
                if (!baseControlInfo) {
                    console.warn('The base control to generate the list was not found'); // eslint-disable-line
                    return state;
                }
                const baseControl = baseControlInfo.control;
                const controlIsList = (control) => control.tag === 'flatList' || control.tag === 'sectionList';
                const baseInnerStyle = (controlIsList(baseControl) && baseControl.contentContainerStyle)
                    || ((0, controlIsLegacy_1.default)((_e = baseControl.controls) === null || _e === void 0 ? void 0 : _e[0])
                        ? (_f = baseControl.controls) === null || _f === void 0 ? void 0 : _f[0].style : undefined);
                const newTag = (shouldAddTabsToList && 'sectionList') || 'flatList';
                const { buildOrders: buildOrdersAfterControlUpdate, flattedControls: flattedControlsAfterControlUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        tag: Controls_1.ControlTag[newTag],
                        contentContainerStyle: baseInnerStyle,
                        inverted,
                        categoryField,
                        listItemControlTemplate,
                        filterEnabled,
                        filterPlaceholder,
                        listStyles,
                        filterProperty,
                        controls: listControls,
                        numColumns,
                        isHorizontal: !!isHorizontal,
                    },
                    functionsToUpdate,
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                return Object.assign(Object.assign({}, state), { flattedControls: Object.assign(Object.assign({}, flattedControlsAfterControlUpdate), listControlsInfo), buildOrders: buildOrdersAfterControlUpdate });
            }
            case AppStateConstants_1.AppStateConstants.BO_UPDATE_SWIPER_CONTENT: {
                const { controlId, listItemControlTemplate, controls: listControls, functionsToUpdate, } = action.payload;
                const { buildOrders: buildOrdersAfterControlUpdate, flattedControls: flattedControlsAfterControlUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        tag: Controls_1.ControlTag.Swiper,
                        isHidden: true,
                        listItemControlTemplate,
                    },
                    functionsToUpdate,
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                const { buildOrders: buildOrdersAfterControlsAdded, flattedControls: flattedControlsAfterControlsAdded, } = (0, addControlsToParent_1.default)({
                    buildOrders: buildOrdersAfterControlUpdate,
                    flattedControls: flattedControlsAfterControlUpdate,
                    parentId: controlId,
                    controlsToAdd: listControls,
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                return Object.assign(Object.assign({}, state), { flattedControls: flattedControlsAfterControlsAdded, buildOrders: buildOrdersAfterControlsAdded });
            }
            case AppStateConstants_1.AppStateConstants.BO_ADD_ITEMS_TO_FLAT_LIST: {
                const { controlId, controls: newControls, listControlsInfo, } = action.payload;
                const controlInfo = state.flattedControls[controlId];
                if (!controlInfo) {
                    return state;
                }
                const originalControls = controlInfo.control.controls || [];
                const { buildOrders: buildOrdersAfterMainUpdate, flattedControls: flattedControlsAfterMainUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        controls: [...originalControls, ...newControls],
                    },
                    shouldNotResetDynamicLoadingEnabled: false,
                });
                return Object.assign(Object.assign({}, state), { flattedControls: Object.assign(Object.assign({}, flattedControlsAfterMainUpdate), listControlsInfo), buildOrders: buildOrdersAfterMainUpdate });
            }
            case AppStateConstants_1.AppStateConstants.BO_SET_PALETTE: {
                const originalShadeBases = (0, appStateSelectBOPaletteShadeBases_1.default)(state);
                if (originalShadeBases
                    && originalShadeBases.black === action.payload.black
                    && originalShadeBases.primary === action.payload.primary
                    && originalShadeBases.secondary === action.payload.secondary) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { buildOrders: Object.assign(Object.assign({}, state.buildOrders), { palette: Object.assign(Object.assign({}, state.buildOrders.palette), { shadeBases: {
                                primary: action.payload.primary,
                                secondary: action.payload.secondary,
                                black: action.payload.black,
                            } }) }) });
            }
            case AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_CLOSE: {
                if (state.fullScreenCamera === defaultState.fullScreenCamera) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { fullScreenCamera: defaultState.fullScreenCamera });
            }
            case AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_OPEN: {
                if ((0, appStateSelectFullScreenCameraIsOpened_1.default)(state)) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { fullScreenCamera: Object.assign(Object.assign({}, state.fullScreenCamera), { isOpened: true, isRecord: true, onStopRecord: action.payload.onStopRecord, onTakePicture: action.payload.onTakePicture, onClose: action.payload.onClose, onRejectedPermissions: action.payload.onRejectedPermissions, onQRCodeRead: action.payload.onQRCodeRead, onBarCodeRead: action.payload.onBarCodeRead }) });
            }
            default:
                return state;
        }
    };
};
exports.default = appStateBuildReducer;
